module.exports = __webpack_public_path__ + "static/cercazone_sudest4-1fc05e52842bdf1d1041d0a52c7ed457.jpg";